Link = require('react-router-dom').Link
common = require('./common')
HeaderBar = require('./header_bar')
# ProjectHeaderCKEditor = require('./project_header_ckeditor')
ProjectHeader = require('./project_header')

module.exports = class UserOwnedProjectFigures extends React.Component
  displayName: 'UserOwnedProjectFigures'

  constructor: (props) ->
      super(props)
      projectid = @props.match.params.projectId
      @state = {
          data: { projectid:projectid, project: { } }
      }

  componentDidMount: =>
      common.projectFigures((data) =>
          @setState({data: { project: data.project } })
          document.title = data.project.title
      , @state.data.projectid)

  render: =>
      <div>
          <HeaderBar />
          <ProjectHeader key={Math.random()}
                         project={@state.data.project}
                         userid={@state.userid}
                         roles={@state.roles} />
          <div className='proj_listing'>
              Project figures go here with relevant fields
          </div>
      </div>
